import React, { Component } from "react";

class ComingSoon extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return <div className="coming-soon">Coming Soon</div>;
  }
}

export default ComingSoon;
